export { default } from './ModalContainer.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/ModalContainer/index.js